import React from "react";

import { Button } from "antd";
import { useNavigate } from "react-router-dom";

interface DetailsRendererParams {
  projectRoleRequestId: number;
}

const DetailsRenderer: React.FC<DetailsRendererParams> = ({
  projectRoleRequestId,
}) => {
  const navigate = useNavigate();

  return (
    <Button
      type="link"
      onClick={() =>
        navigate(`staffingRequests/suggestTeamMember/${projectRoleRequestId}`)
      }
    >
      View Details
    </Button>
  );
};

export default DetailsRenderer;
